module.exports = __webpack_public_path__ + "static/Enchante (3)-4078cc34f30a9342ab73db6b058de19a.jpeg";